export const DATE_TIME_FORMATS = {
  displayDate: 'MMM D, YYYY',
  displayTimestamp: 'MMM D, YYYY, h:mm A',
  displayTime: 'h:mm A',
  dvrTime: 'h:mm:ss A',
  tabularDate: 'MM/DD/YYYY',
  monthDay: 'MMM D',
  monthYear: 'MMM YYYY',
  hour: 'h A',
  weekdayDay: 'ddd D',
} as const;

export type DateTimeFormatKey = keyof typeof DATE_TIME_FORMATS;
export type DateTimeFormat = DateTimeFormatKey | string;

export function resolveDateTimeFormat(format: DateTimeFormat): string {
  if (Object.prototype.hasOwnProperty.call(DATE_TIME_FORMATS, format)) {
    return DATE_TIME_FORMATS[format as DateTimeFormatKey];
  }

  return format;
}
